import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X5LessonStore} from '../X5LessonStore';

@observer
export class DeleteSnapshotControls extends React.Component<{ store: X5LessonStore }> {
  render() {
    const {store} = this.props;

    if (store.deleteSnapshot === null)
      return null;

    const deleteSnapshot = store.deleteSnapshot;
    const isFailure = deleteSnapshot.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Deleting snapshot" state={deleteSnapshot.save} align="right"/>

      {
        isFailure &&
        <div className="row justify-content-end" key="delete-actions">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={() => store.beginDeleteSnapshot(deleteSnapshot.lessonSnapshotId)}> Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}> Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
